import { ModelSagres } from "../../model-sagres"

export class Legislacao extends ModelSagres {
    IdEntrega: number
    Situacao: string
    Exercicio: number
    DataEntrega: Date
    Tipo: string
    QtdDocumentos: number

    /**
     * Trata os dados recebidos pela API. Não execute em outras situações
     * @since 20220613
     */
    tratarDadosDaAPI(): void {
        /* if (typeof (this as any).Ref !== 'undefined') {
            this.Referencia = (this as any).Ref
        } */
        if (this.DataEntrega) {
            this.DataEntrega = new Date(this.DataEntrega)
        }
    }
}